import { useRuntimeConfig } from '#imports'
import type { RouteRecordRaw } from 'vue-router'

import type { Market } from '@backmarket/http-api'

import { ROUTES } from './route-names'

export default ({ market }: { market: Market }): RouteRecordRaw[] => {
  const { FF_ENABLE_NEW_REVIEW_COLLECTION_FUNNEL_BY_COUNTRIES } =
    useRuntimeConfig().public

  const enableNewReviewCollectionFunnel =
    FF_ENABLE_NEW_REVIEW_COLLECTION_FUNNEL_BY_COUNTRIES?.includes(
      market.countryCode,
    )

  return [
    {
      name: ROUTES.FORM,
      path: 'review/:orderlineId',
      ...(enableNewReviewCollectionFunnel
        ? {
            component: () =>
              import('./new-review-collection/ReviewCollection.vue'),
            meta: {
              layout: false,
              owners: ['bot-squad-content-front'],
            },
          }
        : {
            component: () =>
              import('./review-collection/pages/ReviewCollection.vue'),
            meta: {
              owners: ['bot-squad-content-front'],
            },
          }),
    },
    {
      name: ROUTES.PAGES.LANDING,
      path: 'r/l/:slugV2/:uuid',
      component: () => import('./reviews-display/pages/Reviews.vue'),
      meta: {
        owners: ['bot-squad-content-front'],
      },
    },
    {
      name: ROUTES.PAGES.MERCHANT,
      path: 'r/s/:merchantName/:uuid',
      component: () => import('./reviews-display/pages/Reviews.vue'),
      meta: {
        owners: ['bot-squad-content-front'],
      },
    },
    {
      name: ROUTES.PAGES.ALL,
      path: 'r',
      component: () => import('./reviews-display/pages/Reviews.vue'),
      meta: {
        owners: ['bot-squad-content-front'],
      },
    },
  ]
}
